import { render } from "./GalleryBlock.vue?vue&type=template&id=5b54a119&scoped=true"
import script from "./GalleryBlock.vue?vue&type=script&lang=js"
export * from "./GalleryBlock.vue?vue&type=script&lang=js"

import "./GalleryBlock.vue?vue&type=style&index=0&id=5b54a119&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b54a119"]])

export default __exports__